import React, { useState, useEffect } from 'react';
import { templatesAPI } from '../api';

export default function GameTemplates() {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = async () => {
    try {
      const response = await templatesAPI.getAll();
      setTemplates(response.data.templates);
    } catch (error) {
      console.error('Error fetching templates:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-xl text-gray-600">Loading templates...</div>
      </div>
    );
  }

  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold text-gray-800 mb-8">Quizzler Official Games</h1>

      {/* Templates Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {templates.map((template) => (
          <div
            key={template.id}
            className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition cursor-pointer"
            onClick={async () => {
  try {
    const response = await templatesAPI.getOne(template.id);
    setSelectedTemplate(response.data.template);
  } catch (error) {
    console.error('Error fetching template:', error);
    setSelectedTemplate(template); // Fallback to list data
  }
}}
          >
            {/* Official Badge */}
            {template.is_official && (
              <div className="inline-block bg-teal-100 text-teal-700 px-3 py-1 rounded-full text-xs font-semibold mb-3">
                ⭐ Official
              </div>
            )}

            <h3 className="text-xl font-bold text-gray-800 mb-2">{template.title}</h3>
            <p className="text-gray-600 text-sm mb-4">{template.description}</p>
            
            <div className="text-sm text-gray-500">
              📝 {template.question_count || template.questions?.length || 0} questions
            </div>
          </div>
        ))}
      </div>

      {/* Template Detail Modal */}
      {selectedTemplate && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl p-8 max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-start mb-6">
              <div>
                <h2 className="text-3xl font-bold text-gray-800 mb-2">{selectedTemplate.title}</h2>
                <p className="text-gray-600">{selectedTemplate.description}</p>
              </div>
              <button
                onClick={() => setSelectedTemplate(null)}
                className="text-gray-500 hover:text-gray-700 text-2xl"
              >
                ✕
              </button>
            </div>

            {/* Questions List */}
            <div className="space-y-4">
              <h3 className="text-xl font-bold text-gray-800 mb-4">Questions</h3>
              {selectedTemplate.questions?.map((q, idx) => (
                <div key={idx} className="border border-gray-200 rounded-lg p-4">
                  <div className="flex items-start gap-3">
                    <span className="bg-teal-100 text-teal-700 px-3 py-1 rounded-full text-sm font-semibold">
                      Q{idx + 1}
                    </span>
                    <div className="flex-1">
                      <p className="text-sm text-gray-500 mb-1">{q.category}</p>
                      <p className="font-semibold text-gray-800 mb-2">{q.text}</p>
                      <p className="text-sm text-gray-600">
                        <span className="font-semibold">Answer:</span> {q.answer}
                      </p>
                      {q.type === 'visual' && (
                        <span className="inline-block mt-2 bg-orange-100 text-orange-700 px-2 py-1 rounded text-xs">
                          Visual Round
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <button
              onClick={() => setSelectedTemplate(null)}
              className="w-full mt-6 bg-gray-200 hover:bg-gray-300 text-gray-700 px-6 py-3 rounded-lg font-semibold transition"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
